var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$apollo.loading)?_c('article',[_c('page-header',{attrs:{"content":_vm.content}}),_c('prismic-body',{attrs:{"uid":_vm.uid}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }